import BASEAPI from '@/api/dataBase.js';
import tradeMixin from './../../../../../../mixin/tradeMixin';
export const formFields = (ctx) => {
  return [
    {
      prop: 'settlementCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      disabled:
        ['create'].includes(ctx.$route.query?.status) && ctx.$route.query?.id
          ? true
          : !ctx.isCreate,
    },
    {
      prop: 'settlementDepartmentNo',
      name: '部门',
      type: 'select',
      disabled:
        ['create'].includes(ctx.$route.query?.status) && ctx.$route.query?.id
          ? true
          : ctx.baseFormData?.settlementCompanyNo == '' || !ctx.isCreate,
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'parkWarehouseContract',
      extraData: {
        parkCompanyCode: ctx.baseFormData.settlementCompanyNo,
        businessDepartmentCode: ctx.baseFormData.settlementDepartmentNo,
      },
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
      currentValue: ctx.baseFormData?.contractNo,
      disabled: !ctx.isCreate,
    },
    {
      name: '客户名称',
      prop: 'customerName',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        companyCode: ctx.baseFormData.settlementCompanyNo,
        departmentCode: ctx.baseFormData.settlementDepartmentNo,
        partnerTypes: 'HZHB01',
      },
      isMultiple: true,
      changeMethod: ctx.changeCustomsMethod,
      currentValue: ctx.baseFormData?.customerName,
      // disabled: !ctx.isCreate,
      disabled: true,
    },
    // {
    //   name: '订单编号',
    //   prop: 'orderCode',
    //   type: 'searchTableSpec',
    //   searchType: 'mulTransportOrder',
    //   extraData: {
    //     companyCode: ctx.baseFormData.settlementCompanyNo,
    //     departmentCode: ctx.baseFormData.settlementDepartmentNo,
    //     orderStatus: 'completed',
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeOrderMethod,
    //   currentValue: ctx.baseFormData?.orderCode,
    //   // disabled: !ctx.isCreate,
    //   disabled: true,
    // },
    {
      name: '结算单编号',
      prop: 'receivableSettlementNo',
      disabled: true,
      type: 'input',
      // placeholder: '自动生成',
    },
    {
      name: '结算日期',
      prop: 'settlementDate',
      type: 'date',
      changeMethod: 'changeSettlementDateHandler',
      disabled: !ctx.isCreate,
    },
    {
      name: '项目编号',
      prop: 'projectInitiationNo',
      type: 'input',
      // disabled: !ctx.isCreate,
      disabled: true,
    },

    {
      name: '原币结算总金额（含税）',
      prop: 'originalTotalAmount',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    {
      name: '原币结算总金额(不含税)',
      prop: 'originalTotalAmountWithoutTax',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    // {
    //   name: '原币总税额',
    //   prop: 'originalTotalTaxAmount',
    //   type: 'input',
    //   precision: 2,
    //   max: 999999999,
    //   disabled: true,
    // },
    {
      name: '本币结算总金额（含税）',
      prop: 'domesticTotalAmount',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    {
      name: '本币结算总金额(不含税)',
      prop: 'domesticTotalAmountWithoutTax',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    // {
    //   name: '本币总税额',
    //   prop: 'domesticTotalTaxAmount',
    //   type: 'input',
    //   precision: 2,
    //   max: 999999999,
    //   disabled: true,
    // },
    {
      name: '结算类型',
      prop: 'settlementType',
      type: 'select',
      options: ctx.dictListMap?.settlementType || [],
      disabled: !ctx.isCreate,
    },
    {
      name: '币种',
      prop: 'currencyCode',
      type: 'ajaxSelect',
      apiUrl: BASEAPI.LIST_CURRENCY,
      clearable: true,
      filterable: true,
      valueKey: 'currencyCode',
      labelKey: 'currencyName',
      changeMethod: 'changeCurrencyHandler',
      method: 'get',
      valueType: 'object',
      // disabled: !ctx.isCreate,
      disabled: true,
    },
    {
      name: '汇率日期',
      prop: 'exchangeDate',
      type: 'date',
      disabled: !ctx.isCreate,
    },
    {
      name: '汇率值',
      prop: 'exchangeRate',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      // disabled: !ctx.isCreate,
      disabled: true,
    },
    {
      name: '单据状态',
      prop: 'settlementStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementStatus || [],
      disabled: true,
    },
    {
      name: '开票状态',
      prop: 'settlementIssueStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementIssueStatus || [],
      disabled: true,
    },
    {
      name: '开票金额',
      prop: 'invoiceAmount',
      type: 'input',
      precision: 2,
      disabled: true,
    },
    {
      name: '已收款金额',
      prop: 'collectedAmount',
      type: 'input',
      precision: 2,
      disabled: true,
    },
    {
      name: '业务人员',
      prop: 'salesmanName',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changePersonnelMethod,
      currentValue: ctx.baseFormData?.salesmanName,
      // disabled: !ctx.isCreate,
      disabled: true,
    },
    // {
    //   name: '编制人员',
    //   prop: 'weaveName',
    //   type: 'searchTableSpec',
    //   searchType: 'personnel',
    //   isMultiple: true,
    //   changeMethod: ctx.changeWeaveMethod,
    //   currentValue: ctx.baseFormData?.weaveName,
    //   disabled: !ctx.isCreate,
    // },
    {
      name: '创建日期',
      prop: 'settlementCreateDate',
      type: 'date',
      disabled: true,
    },

    {
      name: '业务类别',
      prop: 'settlementBusinessType',
      type: 'select',
      options: ctx.dictListMap?.businessCategory || [],
      disabled: true,
    },
    {
      name: '应收账期',
      prop: 'receivableAccountPeriod',
      type: 'date',
      format: 'yyyy-MM',
      disabled: !ctx.isCreate,
    },
    {
      name: '收款状态',
      prop: 'receiveStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementReceiveStatus || [],
      disabled: true,
    },
    {
      name: '已打印',
      prop: 'printFlag',
      type: 'checkbox',
      disabled: true,
    },
    {
      name: '备注',
      prop: 'remark',
      type: 'textarea',
      span: 24,
      disabled: !ctx.isCreate,
    },
  ];
};

export const formRules = {
  settlementCompanyNo: [{ required: true, message: '公司名称必填', trigger: 'change' }],
  settlementDepartmentNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  customerName: [{ required: true, message: '必填字段', trigger: 'change' }],
  // orderCode: [{ required: true, message: '必填字段', trigger: 'change' }],
  originalTotalAmount: [{ required: true, message: '必填字段', trigger: 'change' }],
  domesticTotalAmount: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementDate: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementType: [{ required: true, message: '必填字段', trigger: 'change' }],
  currencyCode: [{ required: true, message: '必填字段', trigger: 'change' }],
  exchangeDate: [{ required: true, message: '必填字段', trigger: 'change' }],
  salesmanName: [{ required: true, message: '必填字段', trigger: 'change' }],
  weaveName: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementBusinessType: [{ required: true, message: '必填字段', trigger: 'change' }],
  receivableAccountPeriod: [{ required: true, message: '必填字段', trigger: 'change' }],
  contractNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  exchangeRate: [{ required: true, message: '必填字段', trigger: 'blur' }],
};

export const editFormRules = {
  settlementStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementIssueStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementCreateDate: [{ required: true, message: '必填字段', trigger: 'change' }],

  // settlementIssueStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // receiveStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // invoiceAmount: [{ required: true, message: '必填字段', trigger: 'blur' }],
  // collectedAmount: [{ required: true, message: '必填字段', trigger: 'blur' }],
};
import { formatDate } from '@/utils';
// 暴露出去
export default {
  mixins: [tradeMixin],
  data() {
    return {
      formRules,
      baseFormData: {
        settlementCompanyNo: '',
        settlementCompanyName: '',
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        customerName: '',
        customerNo: '',
        // orderCode: '',
        receivableSettlementNo: '',
        settlementDate: '',
        projectInitiationNo: '',
        projectName: '',
        contractNo: '',
        domesticTotalAmount: '',
        settlementType: '2',
        currencyCode: '',
        currencyName: '',
        exchangeDate: '',
        exchangeRate: '',
        settlementStatus: '',
        settlementIssueStatus: '02',
        invoiceAmount: '',
        collectedAmount: '',
        salesmanNo: '',
        salesmanName: '',
        weaveNo: '',
        weaveName: '',
        settlementCreateDate: formatDate(new Date()),
        originalTotalAmount: '',
        settlementBusinessType: '03',
        receivableAccountPeriod: '',
        receiveStatus: '',
        printFlag: '',
        remark: '',
      },
      productList: [],
      isCreate: false,
    };
  },
  watch: {
    'baseFormData.settlementDate': {
      deep: true,
      handler: function (newV) {
        console.log('watch中：', newV);
        this.baseFormData.receivableAccountPeriod =
          newV || this.baseFormData.receivableAccountPeriod;
      },
    },
  },
  computed: {
    formColumn() {
      return formFields(this);
    },
    baseFormRules() {
      if (this.isCreate) {
        return formRules;
      } else {
        return { ...formRules, ...editFormRules };
      }
    },
  },
  methods: {
    // 切换公司
    changeCompanyHandler(val) {
      console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        settlementCompanyNo: val,
        settlementCompanyName: item.personCompanyName,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      console.log(val, '切换部门');
      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: val,
        settlementDepartmentName: item.personDepartmentName,
      };
    },
    // 修改客户
    changeCustomsMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        customerName: rowData?.partnerZhName,
        customerNo: rowData?.partnerCode,
      };
    },
    // 修改订单
    changeOrderMethod(val) {
      const rowData = val[0];
      console.log(rowData, '修改订单');
      this.baseFormData = {
        ...this.baseFormData,
        orderCode: rowData?.orderCode,
      };
    },
    //
    // 修改合同
    changeContractMethod(val) {
      const rowData = val[0];
      console.log(rowData, 'rowData');
      this.baseFormData = {
        ...this.baseFormData,
        contractNo: rowData?.contractNo,
        customerName: rowData?.customerNameOne,
        customerNo: rowData?.customerCodeOne,
        projectInitiationNo: rowData?.projectCode,
        projectName: rowData?.projectName,
        exchangeRate: '1',
        currencyCode: 'CNY',
        currencyName: '中国人民币（国际）',
      };
      this.settleAccountsRowList = [];
      this.$refs.linesRef.removeRowHandler();
      this.settleAccountsDetailMap = new Map();
      this.$refs?.lineDetails?.removeRowHandler();
      this.currentSettleAccountDetailList = [];
      this.currentSettleAccountRowData = null;
      this.currentDetailData = {};
      this.baseFormData = {
        ...this.baseFormData,
        originalTotalAmount: '0',
        originalTotalAmountWithoutTax: '0',
        originalTotalTaxAmount: '0',
        domesticTotalAmount: '0',
        domesticTotalAmountWithoutTax: '0',
        domesticTotalTaxAmount: '0',
      };
      // if (rowData.orderDetailList && rowData.orderDetailList.length) {
      //   this.productList = [];
      //   rowData.orderDetailList.map((item) => {
      //     if (item.contractMatterName && item.contractMatter) {
      //       this.productList.push({
      //         label: item.contractMatterName,
      //         value: item.contractMatter,
      //       });
      //     }
      //   });
      // }
    },
    // 修改业务员
    changePersonnelMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        salesmanNo: rowData?.personNo,
        salesmanName: rowData?.personName,
      };
    },
    // 修改编制人员
    changeWeaveMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        weaveNo: rowData?.personNo,
        weaveName: rowData?.personName,
      };
    },
    // 切换货币
    changeCurrencyHandler({ val }) {
      this.baseFormData = {
        ...this.baseFormData,
        currencyCode: val?.currencyCode,
        currencyName: val?.currencyName,
      };
      this.$emit('changeCurrencyHandler', val);
    },
    changeSettlementDateHandler(val) {
      console.log(val, '日期');

      this.$emit('changeSettlementDateHandler', val);
    },
  },
  mounted() {
    this.isCreate = ['create', 'edit'].includes(this.$route.query?.status);
    // console.log(this.dictListMap?.settlementIssueStatus, '单据状态');
  },
};
